export default __webpack_public_path__ + "static/media/clg.06bf7591.jpg";